document.addEventListener("DOMContentLoaded", function() {
  const wishlistButtons = document.querySelectorAll(".wishlist-button");
  let wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");

  wishlistButtons.forEach(button => {
    const handle = button.dataset.productHandle;
    if (wishlist.includes(handle)) {
      button.classList.add("added");
      const label = button.querySelector(".wishlist-label");
      if (label) label.textContent = "Added to Wishlist ❤️";
    }

    button.addEventListener("click", function() {
      const label = this.querySelector(".wishlist-label");
      if (wishlist.includes(handle)) {
        wishlist = wishlist.filter(item => item !== handle);
        this.classList.remove("added");
        if (label) label.textContent = "Add to Wishlist";
      } else {
        wishlist.push(handle);
        this.classList.add("added");
        if (label) label.textContent = "Added to Wishlist ❤️";
      }
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    });
  });
});
